<template>
    <div class="wapper">
        <el-container style="100%">
            <el-main style="background: #fff">
                <div class="table-wrap" v-show="listShow">
                    <div class="handle-box3">
                        <el-form
                                :inline="true"
                                ref="form"
                                :model="searchForm"
                                class="demo-form-inline"
                        >
                            <div class="uers-left">
                                <el-form-item label="搜索：">
                                    <el-input v-model="searchForm.name" placeholder="名称"></el-input>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-input v-model="searchForm.code" placeholder="批次号"></el-input>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-date-picker v-model="searchForm.startDate" type="datetime"
                                                    placeholder="开始日期"></el-date-picker>
                                </el-form-item>
                                <el-form-item label="">
                                    <el-date-picker v-model="searchForm.endDate" type="datetime"
                                                    placeholder="开始日期"></el-date-picker>
                                </el-form-item>
                                <el-button
                                        type="primary"
                                        icon="el-icon-search"
                                        @click="searchSubmit"
                                >搜索
                                </el-button
                                >
                            </div>
                            <div class="uers-right">
                <span class="btn-r">
                  <el-button
                          type="primary"
                          plain
                          icon="el-icon-plus"
                          @click="addSubmit"
                  >新增</el-button
                  >
                </span>
                            </div>
                        </el-form>
                    </div>
                    <div class="tabbox">
                        <el-table
                                :data="dataList"
                                height="100%"
                                border
                                class="tabbox"
                                ref="multipleTable"
                                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                                @selection-change="handleSelectionChange"
                        >
                            <el-table-column
                                    type="selection"
                                    width="100"
                                    align="center"
                            ></el-table-column>
                            <el-table-column prop="name" label="名称" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.name }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="code"
                                    label="批次号"
                                    width="100"
                                    align="center"
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.row.code }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="remark" label="备注" align="center">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.remark }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    prop="createDate"
                                    label="创建时间"
                                    align="center"
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.row.createDate }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" align="center">
                                <template slot-scope="scope">
                                    <el-button
                                            type="text"
                                            @click="handleEdit(scope.$index, scope.row)"
                                    >下载文件
                                    </el-button
                                    >
                                    <el-button
                                            type="text"
                                            class="red"
                                            @click="handleDelete(scope.$index, scope.row)"
                                    >删除
                                    </el-button
                                    >
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="fb">
                        <el-pagination
                                class="pag"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[5, 10, 15, 20, 50, 100]"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                                background
                        ></el-pagination>
                    </div>
                </div>
            </el-main>
        </el-container>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                total: 0, //总条数
                currentPage: 1, //初始页
                pageSize: 10, // 每页的数据
                //表格高度适配
                tabheight: "",
                searchForm: {
                    name: "",
                    code: "",
                    endDate: new Date(
                        new Date(new Date().toLocaleDateString()).getTime() +
                        24 * 60 * 60 * 1000 -
                        1
                    ),
                    startDate: new Date(
                        new Date(new Date().toLocaleDateString()).getTime()
                    ),
                },
                editData: {},
                listShow: true,
                delVisible: false,
                ticketCom_Id: "",
                editShow: false,
                dataList: [],
                multipleSelection: [],
                projectId: localStorage.getItem("project_Id"),
            };
        },
        mounted() {
            // this.tabheight=(this.$refs.getheight.offsetHeight-165)
        },
        created() {
            this.searchSubmit();
        },
        methods: {
            handleSizeChange(val) {
                this.pagesize = val;
                this.searchSubmit();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.searchSubmit();
            },
            handleEdit(index, row) {
                window.open(row.url);
            },
            searchSubmit() {
                var search = {
                    name: this.searchForm.name,
                    code: this.searchForm.code,
                    startDate: this.searchForm.startDate,
                    endDate: this.searchForm.endDate,
                    pageIndex: this.currentPage - 1,
                    pageSize: this.pagesize,
                    projectId: this.projectId,
                };
                this.$axios.post("/ProjectFile/Search", search).then((res) => {
                    if (res.data.hasError == false) {
                        this.dataList = [...res.data.data];
                        this.total = res.data.total;
                    }
                });
            },
            addSubmit() {
                this.ticketCom_Id = null;
                this.editData = null;
                this.listShow = false;
                this.editShow = true;
            },
            handleDelete(index, row) {
                this.ticketCom_Id = row.projectFileId;
                this.delVisible = true;
            },
            deleteData() {
                this.$axios.delete(`/ProjectFile/${this.ticketCom_Id}`).then((res) => {
                    if (res.data.hasError) {
                        this.$message.error(res.data.message);
                    } else {
                        this.$message.success("删除成功！");
                        this.delVisible = false;
                        this.searchSubmit();
                    }
                });
            },
            handleCloseVisible() {
                this.ticketCom_Id = "";
                this.delVisible = false;
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            getFunStu() {
                this.listShow = true;
                this.editShow = false;
                this.searchSubmit();
            },
        },
    };
</script>
<style lang="scss" scope>
    .pag {
        position: absolute;
        bottom: 0;
    }

    .table-wrap {
        margin-left: 10px;
        height: 100%;
    }

    .el-main {
        border-radius: 5px;
        position: relative;
    }

    .uers-left {
        float: left;
    }

    .uers-right {
        float: right;
    }

    .el-dialog {
        height: auto;
    }
</style>